export class FaqItem {
    FaqID?: number;
    Category?: string;
    Question?: string;
    Answer?: string;
    Display?: boolean = false;
}



// WEBPACK FOOTER //
// ./src/services/faq/faq.model.ts